import {
  Card,
  CardActionArea,
  Grid,
  Hidden,
  Icon,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useStyles } from "./EntryMethodStyles";

type MeanOfIncomeProps = {
  title: string;
  iconUrl: any;
  action: any;
  tabIndex?: number;
  id: string;
  select: string;
  onSelected: (value: string) => void;
};

const EntryMethod = ({
  id,
  title,
  iconUrl,
  tabIndex,
  select,
  onSelected,
}: MeanOfIncomeProps) => {
  const classes = useStyles();
  return (
    <Card
      className={(select === id ? classes.selected : "") + " " + classes.card}
    >
      <CardActionArea
        onClick={() => onSelected(id)}
        className={classes.action}
        tabIndex={tabIndex}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Icon>
              <Hidden smDown>
                <img src={iconUrl} alt={title} className={classes.icon} />
              </Hidden>
              <Hidden mdUp>
                <img src={iconUrl} alt={title} className={classes.iconSm} />
              </Hidden>
            </Icon>
          </Grid>
          <Grid item>
            <Typography className={classes.title} gutterBottom>
              {title}
            </Typography>
          </Grid>
        </Grid>
      </CardActionArea>
    </Card>
  );
};

export default EntryMethod;
